<template>
   <span>
       <button class="ui tiny icon button" :class="isEmpty ? 'basic' : 'inverted blue'" title="Kommentar bearbeiten" @mousedown.prevent="toggleInput()">
          <i class="ui comment icon"></i>
       </button>
      <div class="ui hover segment" :style="{display: showInput ? 'block' : 'none'}">
         <div class="ui fluid icon input">
            <input ref="commentInput" @blur="toggleInput(false)" type="text" placeholder="Kommentar" :value="comment" @input="emitInput">
            <i v-if="comment" class="trash icon link" @mousedown.prevent="clearInput"></i>
         </div>
      </div>
   </span>
</template>

<script>

    export default {
        name: 'CommentInput',
        props: ['comment'],
        data: function () {
            return {
                showInput: false
            }
        },
        computed: {
            isEmpty: function() {
                return this.comment == null || this.comment.trim().length == 0;
            }
        },
        methods: {
            toggleInput(value) {
                if(value == undefined) {
                    value = !this.showInput;
                }

                this.showInput = value;

                if(value) {
                    this.$nextTick(() => {
                        this.$refs.commentInput.focus();
                    });
                }
            },
            clearInput() {
                this.emitInput("");
            },
            emitInput(value) {
                this.$emit('input', (typeof value === "string") ? value : value.target.value);
            }
        }
    }
</script>

<style scoped>
   .hover {
      position: absolute !important;
      width: 500px;
      min-width: 30vw;
      z-index: 10;
   }
</style>